<div class="container-fluid entry-wrapper" [style.background-image]="'url(' + appSvc.bgUrl + ')'">
  <router-outlet></router-outlet>
</div>